"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _editableField = _interopRequireDefault(require("../../core/editable-field"));
var _Class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const TierFees = (_Class = class TierFees extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onChange", (value, field) => {
      this.props.onUpdate(this.props.tier.id, field, value);
    });
  }
  render() {
    if (!this.props.tier) return null;
    const tier = this.props.tier;
    const tierRowSpan = this.props.tierRowSpan;
    return /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
      rowSpan: tierRowSpan,
      className: "text-xs-left read-only"
    }, tier.tierDescription), /*#__PURE__*/_react.default.createElement("td", {
      rowSpan: tierRowSpan,
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: true,
      name: "isFreeToEnter",
      checked: tier.isFreeToEnter,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("td", {
      rowSpan: tierRowSpan,
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "entryFee",
      value: tier.entryFee,
      onChange: this._onChange,
      maxLength: 4,
      required: true
    })), /*#__PURE__*/_react.default.createElement("td", {
      rowSpan: tierRowSpan,
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "lateFee",
      value: tier.lateFee,
      onChange: this._onChange,
      maxLength: 4,
      required: true
    })), /*#__PURE__*/_react.default.createElement("td", {
      rowSpan: tierRowSpan,
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "levy",
      value: tier.levy,
      onChange: this._onChange,
      maxLength: 4,
      required: true
    })), /*#__PURE__*/_react.default.createElement("td", {
      rowSpan: tierRowSpan,
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-center",
      type: "Integer",
      name: "lateFeesLeadTime",
      value: tier.lateFeesLeadTime,
      onChange: this._onChange,
      maxlength: 3,
      required: true
    })));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}, _defineProperty(_Class, "partialQueries", {
  DefaultTiers: {
    id: true,
    tierDescription: true,
    lateFeesLeadTime: true,
    isFreeToEnter: true,
    entryFee: true,
    lateFee: true,
    levy: true
  }
}), _Class);
// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = TierFees;